import { render, staticRenderFns } from "./TreatmentPlanReview.vue?vue&type=template&id=04def308"
import script from "./TreatmentPlanReview.vue?vue&type=script&lang=js"
export * from "./TreatmentPlanReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports